<div class="role-placeholder">
	<div class="role-content">
		@if (this.role === 'General') {
			<h3>{{ 'ROLE.WELCOME' | translate }}<b id="role-text">{{ 'ROLE.CATALOG' | translate }}</b></h3>

			<div 
				class="info-cards"
				[style.gridTemplateColumns]="'repeat(' + getVisibleCardsCount() + ', 1fr)'"
			>

				@if (isAdmin) {
					<div class="card" id="provider-card">
						<div class="card-body">
							{{ 'ROLE.ACCESS' | translate }}
							<b id="role-text">{{ 'HEADER.ADMINISTRATOR' | translate }}</b>
							{{ 'ROLE.ADMINISTRATOR-TAB' | translate }}
						</div>
					</div>
				}

				<div class="card" id="consumer-card">
					<div class="card-body">
						{{ 'ROLE.ACCESS' | translate }}
						<b id="role-text">{{ 'HEADER.CATALOG' | translate }}</b>
						{{ 'ROLE.CATALOG-TAB' | translate }}
					</div>
				</div>

			</div>
		} @else {
			<h3>{{ 'ROLE.ERROR' | translate }}</h3>
		}
	</div>
</div>